import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const CompanyCtx = createContext(null);
export const useCompany = () => useContext(CompanyCtx);

export function CompanyProvider({ children }) {
  const { user } = useAuth();
  const [active, setActive] = useState(null);
  const [switching, setSwitching] = useState(false);
  const companies = user ? user.companies || [] : [];
  const activeId = active?.id || active?.company_id || null;

  const load = async (cid) => {
    if (!cid) { setActive(null); return; }
    setSwitching(true);
    try {
      const { data } = await api.get("/companies/active", { headers: { "X-Company-ID": cid } });
      setActive(data);
    } catch {
      setActive(null);
    } finally {
      setSwitching(false);
    }
  };

  useEffect(() => {
    if (!user) { setActive(null); return; }
    const stored = localStorage.getItem("kg_company");
    const valid = companies.find((c) => c.company_id === stored);
    const cid = valid ? stored : companies[0]?.company_id;
    if (cid) {
      localStorage.setItem("kg_company", cid);
      load(cid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const switchCompany = (cid) => {
    localStorage.setItem("kg_company", cid);
    load(cid);
  };

  const role = active?.role || companies.find((c) => c.company_id === activeId)?.role || "view_only";

  return (
    <CompanyCtx.Provider value={{ companies, active, activeId, role, switching, switchCompany, reload: () => activeId && load(activeId) }}>
      {children}
    </CompanyCtx.Provider>
  );
}
